import React, { useState, useCallback } from 'react'
import './ripple.css'

interface RippleProps {
  children: React.ReactNode
  color?: string
  duration?: number
  className?: string
  disabled?: boolean
}

interface RippleItem {
  x: number
  y: number
  size: number
  id: number
}

export default function Ripple({ 
  children, 
  color = 'rgba(0, 0, 0, 0.4)', 
  duration = 800,
  className = '',
  disabled = false
}: RippleProps) {
  const [ripples, setRipples] = useState<RippleItem[]>([])

  const addRipple = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
    if (disabled) return

    const target = event.currentTarget
    const rect = target.getBoundingClientRect()
    
    const touch = event.touches[0]
    const clientX = touch.clientX
    const clientY = touch.clientY

    const size = Math.max(rect.width, rect.height) * 2
    const x = clientX - rect.left - size / 2
    const y = clientY - rect.top - size / 2

    const rippleId = Date.now() + Math.random()

    const newRipple: RippleItem = {
      x,
      y,
      size,
      id: rippleId
    }

    setRipples(prev => [...prev, newRipple])

    // 自动移除
    setTimeout(() => {
      setRipples(prev => prev.filter(r => r.id !== rippleId))
    }, duration)
  }, [disabled, duration])

  return (
    <div 
      className={`ripple-container ${className}`}
      onTouchStart={addRipple}
    >
      {children}
      {ripples.length > 0 && (
        <div className="ripple-wrapper">
          {ripples.map(ripple => (
            <span
              key={ripple.id}
              className="ripple-effect"
              style={{
                left: ripple.x,
                top: ripple.y,
                width: ripple.size,
                height: ripple.size,
                backgroundColor: color,
                animationDuration: `${duration}ms`
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}
